import { Total } from 'graphql-api/baskets-api-interfaces';

export function getManualDiscount({
  total,
  isManualDiscountApplied,
}: {
  total: Total;
  isManualDiscountApplied: boolean;
}) {
  // discount can be on the product itself or we calculate it on FE
  const isDiscountFromProduct = total.requested.wsp === total.requested.net;
  const confirmedWsp = isDiscountFromProduct
    ? total?.requested?.wsp
    : total?.confirmed?.wsp;

  const differenceWspNet = (confirmedWsp ?? 0) - (total?.simulated?.net ?? 0);

  const value = isManualDiscountApplied ? differenceWspNet * -1 : undefined;
  const percentage = isManualDiscountApplied
    ? differenceWspNet / (confirmedWsp ?? 1)
    : undefined;

  return {
    value,
    percentage,
  };
}
